import { PATH_DELIMITER, SMS_SEND_PATH } from '../../../constant/Constant';
import { SET_GRID_DATA } from '../../component/TableBoxModule';
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { request } from '../../ApiModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import produce from 'immer';

const ACTION_STUDENT_SEARCH = SMS_SEND_PATH + PATH_DELIMITER + 'ACTION_STUDENT_SEARCH';
const ACTION_SMS_SEND = SMS_SEND_PATH + PATH_DELIMITER + 'ACTION_SMS_SEND';
const ACTION_SET_PHONE_DATA = SMS_SEND_PATH + PATH_DELIMITER + 'ACTION_SET_PHONE_DATA';
const ACTION_EXCEL_DOWNLOAD = SMS_SEND_PATH + PATH_DELIMITER + 'ACTION_EXCEL_DOWNLOAD';
const ACTION_SAMPLE_EXCEL_DOWNLOAD = SMS_SEND_PATH + PATH_DELIMITER + 'ACTION_SAMPLE_EXCEL_DOWNLOAD';
export const SET_PHONE_DATA = SMS_SEND_PATH + PATH_DELIMITER + 'SET_PHONE_DATA';

export const actionStudentSearch = createAction(ACTION_STUDENT_SEARCH);
export const actionSmsSend = createAction(ACTION_SMS_SEND);
export const actionSetPhoneData = createAction(ACTION_SET_PHONE_DATA);
export const actionExcelDownload = createAction(ACTION_EXCEL_DOWNLOAD);
export const actionSampleExcelDownload = createAction(ACTION_SAMPLE_EXCEL_DOWNLOAD);
export const handlePhoneData = createAction(SET_PHONE_DATA);

export function* smsSendSagas() {
    yield takeEvery(ACTION_STUDENT_SEARCH, actionStudentSearchSaga);
    yield takeEvery(ACTION_SMS_SEND, actionSmsSendSaga);
    yield takeEvery(ACTION_SET_PHONE_DATA, actionSetPhoneDataSaga);
    yield takeEvery(ACTION_EXCEL_DOWNLOAD, actionExcelDownloadSaga);
    yield takeEvery(ACTION_SAMPLE_EXCEL_DOWNLOAD, actionSampleExcelDownloadSaga);
}

function* actionStudentSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/users/sms/students',
        params,
        callback,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionSmsSendSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/sms-send/send',
        data,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(result);
    }
}

function* actionExcelDownloadSaga({ payload: { params } }) {
    yield call(request, {
        method: 'get',
        url: `/api/users/sms/students/excel-export`,
        params,
        download: true,
        downloadDirect: true,
        downloadType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}

function* actionSampleExcelDownloadSaga({}) {
    yield call(request, {
        method: 'get',
        url: `/api/sms-send/sample-export`,
        download: true,
        downloadDirect: true,
        downloadType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}

function* actionSetPhoneDataSaga({ payload: { data } }) {
    yield put({
        type: SET_PHONE_DATA,
        payload: data,
    });
}

const initialState = {
    phoneData: [],
};

const module = handleActions(
    {
        [SET_PHONE_DATA]: (state, { payload: data }) =>
            produce(state, (draft) => {
                if (data.job === 'allDel') {
                    draft.phoneData = [];
                } else if (data.job === 'add') {
                    var temp = draft.phoneData.slice();
                    temp.push(data.phone);
                    draft.phoneData = temp;
                } else if (data.job === 'del') {
                    var temp = draft.phoneData.slice();
                    temp = temp.filter((a) => a !== data.phone);
                    draft.phoneData = temp;
                } else {
                    console.error('올바르지 않은 job 유형 입니다. : ' + data.job);
                }
            }),
    },
    initialState,
);

export default module;
